import { SHARING_CONTENT, SHARING_EVENT, SHARING_URL, TITLE } from '@/components/Giveback2022/Giveback2022Consts';
import Giveback2022Content from '@/components/Giveback2022/Giveback2022Content';
import Giveback2022Footer from '@/components/Giveback2022/Giveback2022Footer';
import Giveback2022Header from '@/components/Giveback2022/Giveback2022Header';
import Giveback2022LogoSection from '@/components/Giveback2022/Giveback2022LogoSection';
import GivebackShareButton from '@/components/GivebackShared/GivebackShareButton';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useIsClient } from '@/hooks/useIsClient';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/giveback_2022/ogImage.png';
import { useHeaderLayout } from '@/store/useHeaderLayout';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type { NextPage } from 'next';
import React from 'react';
import styled from 'styled-components';
import { GIVEBACK_LANDING_PAGE } from '../utils/productAdaPages';

const ScrollContainer = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (prefers-reduced-motion) {
    height: 40000px;
  }

  ${MEDIA_QUERIES.tabletAndDesktop`
        display: inline;
    `}
`;

const Giveback2022Page: NextPage<{ url: { protocol: string; host: string } }> = () => {
  useShowHeaderCtaOnScroll(true);
  const setState = useHeaderLayout(s => s.setState);

  React.useEffect(() => {
    setState({
      showLogin: false,
    });
  }, [setState]);

  const isClient = useIsClient();

  if (!isClient) {
    return null;
  }

  return (
    <Layout
      {...sharedConfig['en-US'].layout}
      pt={[70, 90, 150]}
      CustomHeaderCTA={
        <GivebackShareButton
          nativeSharing
          event={SHARING_EVENT}
          url={SHARING_URL}
          title={TITLE}
          content={SHARING_CONTENT}
        />
      }
      showUserAccountComponent={false}
      overflow="hidden"
      page={GIVEBACK_LANDING_PAGE}
    >
      <SEO
        title={TITLE}
        metaTitle={TITLE}
        description="59 nonprofits are receiving a donation via the 2022 Lemonade Giveback. Here's the impact that made."
        ogImage={ogImage.src}
      />
      <ScrollContainer>
        <Giveback2022Header />
        <Giveback2022Content />
        <Giveback2022LogoSection />
        <Giveback2022Footer />
      </ScrollContainer>
    </Layout>
  );
};

export default Giveback2022Page;
